import { combineReducers } from 'redux'

import billingTabReducer from './billing-tab'
import sharedReducer from './shared'
import sitesTabReducer from './sites-tab'

const accountReducer = combineReducers({
  billingTab: billingTabReducer,
  shared: sharedReducer,
  sitesTab: sitesTabReducer
})

export default accountReducer
